export default __webpack_public_path__ + "ff6c47a2547885b72d4b1470b67a40e9.jpg";